import React, { useState } from "react";
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
} from "react-share";
import { Menu, MenuItem, Tooltip } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import { toast } from "react-toastify";

const ShareButton = ({ url }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const realtorCode = localStorage.getItem("realtor_code");
    const shareUrl = realtorCode ? url : window.location.href; // Use provided URL or fallback to current page
    const message = encodeURIComponent("Hey, check this out! This might interest you: " + shareUrl);

    // Open/Close Menu
    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    // Copy to Clipboard
    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied to clipboard!");
        handleClose();
    };

    return (
        <div>
            <Tooltip title="Share">
                {/* <IconButton onClick={handleOpen} style={{ marginRight: 8, color: "#dd483b" }}>
                    <ShareIcon />
                </IconButton> */}
                <button onClick={handleOpen} className="orange-filled-btn claimbtn "><span className='me-2'><svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.307 10.7623C10.5404 10.7623 9.8497 11.0934 9.37036 11.62L5.05871 8.94958C5.17708 8.64698 5.23777 8.32491 5.23765 7.99998C5.23779 7.67506 5.1771 7.35298 5.05871 7.05039L9.37036 4.37987C9.84973 4.90649 10.5404 5.23768 11.307 5.23768C12.7511 5.23768 13.9259 4.06287 13.9259 2.61878C13.9259 1.17469 12.7511 0 11.307 0C9.86292 0 8.68811 1.17481 8.68811 2.6189C8.68805 2.94381 8.74873 3.26586 8.86705 3.56846L4.55552 6.23889C4.07615 5.71227 3.38549 5.38108 2.6189 5.38108C1.17481 5.38108 0 6.55602 0 7.99998C0 9.44404 1.17481 10.6189 2.6189 10.6189C3.38546 10.6189 4.07618 10.2878 4.55552 9.76108L8.86708 12.4315C8.74874 12.7341 8.68804 13.0562 8.68811 13.3812C8.68811 14.8252 9.86289 16 11.307 16C12.7511 16 13.9259 14.8252 13.9259 13.3812C13.9259 11.9371 12.7511 10.7623 11.307 10.7623ZM9.64304 2.6189C9.64304 1.7014 10.3895 0.954967 11.307 0.954967C12.2244 0.954967 12.9709 1.7014 12.9709 2.6189C12.9709 3.5364 12.2245 4.28284 11.307 4.28284C10.3895 4.28284 9.64304 3.53637 9.64304 2.6189ZM2.6189 9.66392C1.70128 9.66392 0.954842 8.91745 0.954842 7.99998C0.954842 7.08252 1.70128 6.33605 2.6189 6.33605C3.5364 6.33605 4.28271 7.08252 4.28271 7.99998C4.28271 8.91745 3.53637 9.66392 2.6189 9.66392ZM9.64304 13.3811C9.64304 12.4636 10.3895 11.7171 11.307 11.7171C12.2244 11.7171 12.9709 12.4636 12.9709 13.3811C12.9709 14.2986 12.2245 15.045 11.307 15.045C10.3895 15.045 9.64304 14.2986 9.64304 13.3811V13.3811Z" fill="white" />
                </svg>
                </span>Share</button>

            </Tooltip>


            {/* Share Menu */}
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem onClick={handleClose}>
                    <a href={`mailto:?subject=Check this out&body=${message}`} style={{ display: "flex", alignItems: "center", width: "100%", textDecoration: "none", color: "inherit" }}>
                        <EmailIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Email
                    </a>
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <a href={`sms:?body=${shareUrl}`} style={{ display: "flex", alignItems: "center", width: "100%", textDecoration: "none", color: "inherit" }}>
                        <SmsIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Text Message
                    </a>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                    <FacebookShareButton url={shareUrl} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <FacebookIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Facebook
                    </FacebookShareButton>
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <TwitterShareButton url={shareUrl} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <TwitterIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Twitter
                    </TwitterShareButton>
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <LinkedinShareButton url={shareUrl} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <LinkedInIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> LinkedIn
                    </LinkedinShareButton>
                </MenuItem>

                <MenuItem onClick={handleClose}>
                    <WhatsappShareButton url={shareUrl} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <WhatsAppIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> WhatsApp
                    </WhatsappShareButton>
                </MenuItem>

                <MenuItem onClick={copyToClipboard}>
                    <ContentCopyIcon style={{ marginRight: 8, color: "#6C6C6C" }} /> Copy Link
                </MenuItem>
            </Menu>
        </div>
    );
};

export default ShareButton;
